import { Flex, Text } from "@/atoms"

import stylesRuleCard from "../RuleCard/RuleCard.module.scss"

export const WhatBrokenCell = (value: { id: string; value: string[] }) => (
  <Flex gap={4} align="center">
    <Text>{value.id}</Text>
    <Text type="secondary">is</Text>
    <Text className={stylesRuleCard.tag}>{value.value?.join(", ") || ""}</Text>
  </Flex>
)
